import React from 'react';

import { CreateRumbleItem } from '../../types/RumbleItem';
import CustomImageUpload from '../CustomImageUpload/CustomImageUpload';
import ClearFileInputIcon from '../Icons/ClearFileInputIcon';
import TextArea from '../TextArea/TextArea';
import Label from '../Label/Label';
import Input from '../Input/Input';
import clsx from 'clsx';

export default function Item({
  item,
  disableDelete,
  updateItem,
  removeItem,
  isMobile,
  index,
  emptyName,
  resetEmptyName = () => false,
}: {
  item: CreateRumbleItem;
  disableDelete: boolean;
  updateItem(item: CreateRumbleItem): void;
  removeItem(key: string): void;
  isMobile?: boolean;
  index?: number;
  emptyName?: boolean;
  resetEmptyName?(params: boolean): void;
}) {
  return (
    <div>
      {!isMobile && (
        <div className={'flex justify-end mb-1'}>
          <button
            type={'button'}
            className={clsx(
              'leading-1 text-red font-semibold',
              disableDelete && 'opacity-50'
            )}
            onClick={() => {
              removeItem(item.key);
              resetEmptyName(false);
            }}
            title='Remove item'
            disabled={disableDelete}
          >
            Remove
          </button>
        </div>
      )}
      <div className={'flex gap-4 max-tablet:flex-col'}>
        <div className={'tablet:basis-[281px]'}>
          <Label
            text={'Choose image for your item (recommended)'}
            htmlFor={`itemImage${index}`}
          />
          <div className={'relative h-[175px] max-tablet:h-40'}>
            <CustomImageUpload
              id={`itemImage${index}`}
              onChange={(e) => {
                if (e.length) {
                  updateItem({ ...item, imageFile: e[0], imageURL: '' });
                }
              }}
            />
            {(item.imageFile || item.imageURL) && (
              <>
                <button
                  className={
                    'h-6 w-6 flex items-center justify-center bg-primary/[0.75] rounded-full absolute top-2 right-2 z-10'
                  }
                  onClick={() => {
                    updateItem({ ...item, imageFile: null, imageURL: '' });
                  }}
                  title='Remove image'
                >
                  <ClearFileInputIcon />
                </button>
                {item.imageFile ? (
                  <img
                    className={
                      'absolute w-full h-full top-0 left-0 rounded-8 object-cover'
                    }
                    src={URL.createObjectURL(item.imageFile)}
                    alt={`Thumbnail for ${item.name || 'your new list'}`}
                  />
                ) : (
                  item.imageURL && (
                    <img
                      className={
                        'absolute w-full h-full top-0 left-0 rounded-8 object-cover'
                      }
                      src={item.imageURL}
                      alt={`Thumbnail for ${item.name || 'your new list'}`}
                    />
                  )
                )}
              </>
            )}
          </div>
        </div>
        <div className={'flex flex-col gap-4 flex-grow max-tablet:order-first'}>
          <div>
            <Label
              text={'Name'}
              htmlFor={`itemName${index}`}
              errorText={'Enter Item Name'}
              error={emptyName && item.name === ''}
            />
            <Input
              variant={'text'}
              id={`itemName${index}`}
              value={item.name}
              onChange={(evt) =>
                updateItem({ ...item, name: evt.target.value })
              }
              error={emptyName && item.name === ''}
              placeholder='Give This Item a Name'
            />
          </div>
          <div>
            <Label
              text={'Describe your item'}
              htmlFor={`itemDescribe${index}`}
            />
            <TextArea
              id={`itemDescribe${index}`}
              value={item.description}
              onChange={(evt) =>
                updateItem({ ...item, description: evt.target.value })
              }
              placeholder='Describe This Item'
            />
          </div>
        </div>
      </div>
      {isMobile && (
        <button
          type={'button'}
          className={clsx(
            'w-full leading-1 text-red font-semibold mt-8 mb-4 h-10 py-2.5 px-4 border border-red rounded-6',
            disableDelete && 'opacity-50'
          )}
          onClick={() => removeItem(item.key)}
          title='Remove item'
          disabled={disableDelete}
        >
          Remove
        </button>
      )}
    </div>
  );
}
